import {
  useGetInstallsQuery,
  useGetAppInstallEmbedCodeQuery,
} from 'src/services/api/applicationsApi';

interface UseNotificationIframeUrlProps {
  resourceId?: string;
  notificationId?: string;
}

export const useNotificationIframeUrl = ({
  resourceId,
  notificationId,
}: UseNotificationIframeUrlProps) => {
  const { data: { extensionsSettings } = {} } = useGetInstallsQuery();
  const extension = extensionsSettings?.[resourceId ?? ''];
  const appId = extension?.appId ?? '';
  const url = useGetAppInstallEmbedCodeQuery(
    {
      appId: appId,
      notificationId,
    },
    {
      skip: !notificationId || !appId,
    },
  );

  return url.data ?? '';
};
